import { jsx as _jsx } from "react/jsx-runtime";
export default function ArrowRight(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (_jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8.78325 5.33331L5.04992 1.59998L5.99992 0.666646L11.3333 5.99998L5.99992 11.3333L5.04992 10.4L8.78325 6.66665L0.666585 6.66665L0.666585 5.33331L8.78325 5.33331Z", fill: disabled ? "#DADADA" : "#5F6368" }) }));
}
